import {
    Box, Button, Card, CardActionArea, CardMedia, Icon,
    Paper, Tooltip, Typography, useTheme,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    tableCellClasses, Autocomplete,
    CircularProgress,
    TextField, styled,
    Checkbox as MuiCheckBox,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    InputLabel,
    SelectChangeEvent,
    AutocompleteProps,
} from "@mui/material";
import { ptBR } from '@mui/x-data-grid/locales';
import Grid from '@mui/material/Grid2';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, TDropOptions, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IDadosListaFranquiaLiga, IDadosListaJogadores, IDadosListao, IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";
import { IDadosEstatisticas } from "../../shered/services/api/freeAgency/FreeAgencyService";
import { EstatisticasService, IDadosFiltrosJogadores, IDadosRetornoMeusJogadores, IListaDadosMediaJogadores, IListaDadosMeusJogadores, IListagemMeusJogadores } from "../../shered/services/api/estatisticas/EstatisticasService";
import {
    DataGrid,
    DataGridProps,
    GridActionsCellItem,
    GridCellEditStopReasons,
    GridCellParams,
    GridColDef,
    GridEditSingleSelectCell,
    GridEditSingleSelectCellProps,
    GridEventListener,
    gridFocusCellSelector,
    GridRenderCellParams,
    GridRenderEditCellParams,
    GridRowEditStopReasons,
    GridRowId,
    GridRowModel,
    GridRowModes,
    GridRowModesModel,
    GridRowsProp,
    GridToolbarContainer,
    useGridApiContext
} from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";
import { Cancel } from "@mui/icons-material";

const lstQtdRodadasFiltro = [
    {
        codigo: 5,
        label: "5"
    },
    {
        codigo: 10,
        label: "10"
    },
    {
        codigo: 15,
        label: "15"
    },
    {
        codigo: 20,
        label: "20"
    },
    {
        codigo: 25,
        label: "25"
    },
    {
        codigo: 30,
        label: "30"
    },
    {
        codigo: 35,
        label: "35"
    },
    {
        codigo: 40,
        label: "40"
    },
    {
        codigo: 45,
        label: "45"
    },
    {
        codigo: 50,
        label: "50"
    }
    ,
    {
        codigo: 100,
        label: "100"
    }
];



export const ListagemDeMeusJogadores: React.FC = () => {
    const theme = useTheme();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    //const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [estatisticasRows, setEstatisticasRows] = useState<IListaDadosMeusJogadores[]>([]);
    const [estatisticasTodosRows, setEstatisticasTodosRows] = useState<IListaDadosMeusJogadores[]>([]);
    const [lstRows, setLstRows] = useState<IListaDadosMeusJogadores[]>([]);
    const [lstTodosRows, setLstTodosRows] = useState<IListaDadosMeusJogadores[]>([]);
    const [lstJogadores, setLstJogadores] = useState<ILstDrop[]>([]);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [codigoFranquia, setCodigoFranquia] = useState(0);
    const [codigoJogadorSelecionado, setCodigoJogadorSelecionado] = useState(0);
    const [qtdRodadasFiltro, setQtdRodadasFiltro] = useState(5);
    let remarkPreset: { id: GridRowId; value: string } | undefined;
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});

    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    const [dropJogador0, setDropFranquia0] = useState(0);
    const [dropJogador1, setDropFranquia1] = useState(0);
    const [dropJogador2, setDropFranquia2] = useState(0);
    const [dropJogador3, setDropFranquia3] = useState(0);
    const [dropJogador4, setDropFranquia4] = useState(0);
    const [dropJogador5, setDropFranquia5] = useState(0);
    const [dropJogador6, setDropFranquia6] = useState(0);
    const [dropJogador7, setDropFranquia7] = useState(0);
    const [dropJogador8, setDropFranquia8] = useState(0);
    const [dropJogador9, setDropFranquia9] = useState(0);
    const [dropJogador10, setDropFranquia10] = useState(0);
    const [dropJogador11, setDropFranquia11] = useState(0);
    const [dropJogador12, setDropFranquia12] = useState(0);
    const [dropJogador13, setDropFranquia13] = useState(0);
    const [dropJogador14, setDropFranquia14] = useState(0);
    const [dropJogador15, setDropFranquia15] = useState(0);
    const [dropJogador16, setDropFranquia16] = useState(0);
    const [dropJogador17, setDropFranquia17] = useState(0);
    const [dropJogador18, setDropFranquia18] = useState(0);
    const [dropJogador19, setDropFranquia19] = useState(0);
    const [dropJogador20, setDropFranquia20] = useState(0);
    const [dropJogador21, setDropFranquia21] = useState(0);
    const [dropJogador22, setDropFranquia22] = useState(0);
    const [dropJogador23, setDropFranquia23] = useState(0);
    const [dropJogador24, setDropFranquia24] = useState(0);
    const [dropJogador25, setDropFranquia25] = useState(0);
    const [opcoesAutoCompleteJogador, setOpcoesAutoCompleteJogador] = useState<TDropOptions[]>([]);
    const [selectedIdComplete, setSelectedIdComplete] = useState<number | undefined>(0);
    const [opcoesAutoCompleteJogadorTodos, setOpcoesAutoCompleteJogadorTodos] = useState<TDropOptions[]>([]);
    const [selectedIdCompleteTodos, setSelectedIdCompleteTodos] = useState<number | undefined>(0);
    const autoCompleteSelectedOption = useMemo(() => {
        if (!selectedIdComplete) return null;

        const selectedOption = opcoesAutoCompleteJogador.find(opcao => opcao.codigo === selectedIdComplete);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdComplete, opcoesAutoCompleteJogador]);

    const autoCompleteSelectedOptionTodos = useMemo(() => {
        if (!selectedIdCompleteTodos) return null;

        const selectedOption = opcoesAutoCompleteJogadorTodos.find(opcao => opcao.codigo === selectedIdCompleteTodos);
        if (!selectedOption) return null;

        return selectedOption;
    }, [selectedIdCompleteTodos, opcoesAutoCompleteJogadorTodos]);


    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {                  
                UtilidadeService.getTemporadas(true, Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        setCodigoFranquia(liga.codigo_Franquia);
                        carregarDadosMeusJogadores(liga.codigo_Franquia, liga.codigo_Temporada, qtdRodadasFiltro);
                        carregarDadosTodosJogadores(liga.codigo, liga.codigo_Temporada, qtdRodadasFiltro);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });
            })
        }
    }, []);

    const carregarDadosMeusJogadores = (codigoFraqnuia: number, codigoTemporada: number, qtdJogos: number) => {
        setIsLoading(true);
        setRemoveLoading(false);              
        EstatisticasService.getMeusJogadores(codigoFraqnuia, codigoTemporada, qtdJogos)
            .then((result) => {
                const lstDados = result.dado;
                setEstatisticasRows(lstDados.sort((a, b) => a.nome > b.nome ? 1 : -1));
                let newLst: IListaDadosMeusJogadores[] = [];
                lstDados.forEach(f => newLst.push(f));

                setLstRows(newLst);

                // let lstJogadores = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `setDropJogador${i} ` : f.nome }));
                // setLstJogadores(lstJogadores.sort((a, b) => a.label > b.label ? 1 : -1));
                const lstDrop: TDropOptions[] = result.dado.sort((a, b) => a.nome > b.nome ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.nome, descricao: f.codigo_NBA.toString() }));
                setOpcoesAutoCompleteJogador(lstDrop);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

               // setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const carregarDadosTodosJogadores = (codigoLiga: number, codigoTemporada: number, qtdJogos: number) => {
       
        EstatisticasService.getJogadoresTodos(codigoLiga, codigoTemporada, qtdJogos)
            .then((result) => {
                const lstDados = result.dado;
                setEstatisticasTodosRows(lstDados);
                let lstJogadores = result.dado.map((f, i) => ({ codigo: f.codigo !== undefined ? f.codigo : 0, label: f.nome === null ? `setDropJogador${i} ` : f.nome }));
                const lstDrop: TDropOptions[] = lstJogadores.sort((a, b) => a.label > b.label ? 1 : -1)
                    .map((f, i) => ({ codigo: f.codigo, label: f.label, descricao: "" }));
                setOpcoesAutoCompleteJogadorTodos(lstDrop);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        setEstatisticasRows([]);
        setLstRows([]);
        carregarDadosMeusJogadores(codigoFranquia, Number(e.target.value), qtdRodadasFiltro);
    }

    const handleQuantidadeRodadas = async (e: { target: { name: string; value: any; }; }) => {
        setQtdRodadasFiltro(e.target.value);
        setEstatisticasRows([]);
        setLstRows([]);
        carregarDadosMeusJogadores(codigoFranquia, temporadaFiltro, Number(e.target.value));
    }

    const columnsGeral: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '#',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'actions',
            headerName: '',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            minWidth: 58,
            maxWidth: 58,
            sortable: false,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Excluir"><Cancel style={{color:"red"}} /></Tooltip>}
                    label="Excluir"
                    onClick={() => handleExcluirMeuJogador(params.row.codigo)}
                //disabled={!user.administrador && user.codUsuario !== codigoUsuario}

                />
            ]
        },
        // {
        //     field: 'codigo_NBA',
        //     headerName: '#NBA',
        //     flex: 1,
        //     minWidth: 58,
        //     maxWidth: 58,
        //     headerClassName: 'super-app-theme--header',
        //     align: 'center',
        //     headerAlign: 'center',
        // },
        {
            field: 'foto',
            headerName: 'FOTO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 40 : 65,
            maxWidth: UtilidadeService.isMobile() ? 40 : 65,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 30 : 55} height={UtilidadeService.isMobile() ? 30 : 50} /> : null,
        },
        {
            field: 'nome',
            headerName: 'JOGADOR',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 115 : 250,
            headerClassName: 'super-app-theme--header',
            editable: true,

        },
        {
            field: 'quantidade_Jogos',
            headerName: 'QTD',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            editable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'min',
            headerName: 'MIN',
            editable: false,
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'fgm',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'threepm',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'pts',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


        },
        {
            field: 'reb',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'oreb',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'dreb',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'ast',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'stl',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'blk',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'to',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'pf',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'mplu',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'fgmp',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'ftmp',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'threepmp',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'fte',
            headerName: 'FTE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'fge',
            headerName: 'FGE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'threepe',
            headerName: '3PE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'threepa',
            headerName: '3PA',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'stocks',
            headerName: 'STOCKS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'peso_Total_Jogador',
            headerName: UtilidadeService.isMobile() ? "TOTAL" : 'PESO TOTAL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 70 : 120,
            maxWidth: UtilidadeService.isMobile() ? 70 : 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
    ];

    const columnsGeralTodos: GridColDef[] = [
        {
            field: 'codigo',
            headerName: '#',
            flex: 1,
            minWidth: 58,
            maxWidth: 58,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
        },
        {
            field: 'actions',
            headerName: '',
            headerClassName: 'super-app-theme--header',
            type: 'actions',
            minWidth: 58,
            maxWidth: 58,
            sortable: false,
            getActions: (params) => [
                <GridActionsCellItem
                    icon={<Tooltip title="Excluir"><Cancel style={{color:"red"}} /></Tooltip>}
                    label="Excluir"
                    onClick={() => handleExcluirJogadorTodos(params.row.codigo)}
                //disabled={!user.administrador && user.codUsuario !== codigoUsuario}

                />
            ]
        },
        {
            field: 'foto',
            headerName: 'FOTO',
            editable: false,
            flex: 1,
            minWidth: UtilidadeService.isMobile() ? 40 : 65,
            maxWidth: UtilidadeService.isMobile() ? 40 : 65,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 30 : 55} height={UtilidadeService.isMobile() ? 30 : 50} /> : null,
        },
        {
            field: 'nome',
            headerName: 'JOGADOR',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 115 : 250,
            headerClassName: 'super-app-theme--header',
            editable: true,

        },
        {
            field: 'quantidade_Jogos',
            headerName: 'QTD',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            editable: false,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'min',
            headerName: 'MIN',
            editable: false,
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'fgm',
            headerName: 'FGM',
            editable: false,
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: 60,
            maxWidth: 60,
            headerClassName: 'super-app-theme--header',
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'threepm',
            headerName: '3PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'pts',
            headerName: 'PTS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


        },
        {
            field: 'reb',
            headerName: 'REB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'oreb',
            headerName: 'OREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'dreb',
            headerName: 'DREB',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'ast',
            headerName: 'AST',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'stl',
            headerName: 'STL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            // cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'blk',
            headerName: 'BLK',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'to',
            headerName: 'TO',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'pf',
            headerName: 'PF',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'mplu',
            headerName: 'MPLU',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            cellClassName: (params: GridCellParams<any, number>) => {

                if (params.value == null) {

                    return '';
                }

                return clsx('super-app', {
                    negative: parseFloat(params.value.toString()) < 0,
                    positive: parseFloat(params.value.toString()) >= 0,
                });
            },
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'fgmp',
            headerName: 'FGM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'ftmp',
            headerName: 'FTM%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'threepmp',
            headerName: '3P%',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            //cellClassName: 'super-app-theme--cell',
            renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
        },
        {
            field: 'fte',
            headerName: 'FTE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'fge',
            headerName: 'FGE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'threepe',
            headerName: '3PE',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'threepa',
            headerName: '3PA',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 70,
            maxWidth: UtilidadeService.isMobile() ? 50 : 70,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'stocks',
            headerName: 'STOCKS',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 50 : 80,
            maxWidth: UtilidadeService.isMobile() ? 50 : 80,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
        {
            field: 'peso_Total_Jogador',
            headerName: UtilidadeService.isMobile() ? "TOTAL" : 'PESO TOTAL',
            editable: false,
            headerClassName: 'super-app-theme--header',
            flex: 1,
            sortable: UtilidadeService.isMobile() ? false : true,
            minWidth: UtilidadeService.isMobile() ? 70 : 120,
            maxWidth: UtilidadeService.isMobile() ? 70 : 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
        },
    ];
    const handleAdicionarJogador = (codigo: number) => {
        setSelectedIdComplete(codigo);
        if (typeof codigo !== null && typeof codigo !== undefined) {
            if (lstRows.find(f => f.codigo === Number(codigo))) {
                setShowModalMensagem(true);
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "warning",
                    mensagem: "Jogador já incluído!",
                    display: "none",
                    titulo: "Atenção"
                });
                setSelectedIdComplete(0);
                return;
            }
        }

        let dadosJogador = estatisticasRows.find(f => f.codigo === Number(codigo));
        if (dadosJogador !== undefined) {
            setLstRows([...lstRows, dadosJogador]);
        }
        setTimeout(() => {
            setSelectedIdComplete(0);
        }, 500);

    }

    const handleExcluirMeuJogador = (row: number) => {
        let newList = lstRows.filter((i) => i.codigo != row)
        setLstRows(newList);
    }

    const handleAdicionarJogadorTodos = (codigo: number) => {
            setSelectedIdCompleteTodos(codigo);
            if (typeof codigo !== null && typeof codigo !== undefined) {
                if (lstTodosRows.find(f => f.codigo === Number(codigo))) {
                    setShowModalMensagem(true);
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "warning",
                        mensagem: "Jogador já incluído!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setSelectedIdCompleteTodos(0);
                    return;
                }
            }

            let dadosJogador = estatisticasTodosRows.find(f => f.codigo === Number(codigo));
            if (dadosJogador !== undefined) {
                setLstTodosRows([...lstTodosRows, dadosJogador]);
            }
            setTimeout(() => {
                setSelectedIdCompleteTodos(0);
            }, 500);
        }

    const handleExcluirJogadorTodos = (row: number) => {
        let newList = lstTodosRows.filter((i) => i.codigo != row)
        setLstTodosRows(newList);
    }

    return (
        <LayoutBaseDePagina
            titulo={`Média Times - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Meus Jogadores </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={handleSelectedTemporada}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Quantidade Rodadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={qtdRodadasFiltro}
                                            label="Quantidade Rodadas"
                                            onChange={handleQuantidadeRodadas}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstQtdRodadasFiltro.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }
                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid container size={{ xs: 11, sm: 12 }} margin={1} paddingTop={1} spacing={1} display="flex" justifyItems="center" >
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <Autocomplete
                                        openText="Abrir"
                                        closeText="Fechar"
                                        noOptionsText="Sem opções"
                                        loadingText="Carregando..."
                                        disablePortal
                                        options={opcoesAutoCompleteJogador}
                                        loading={isLoading}
                                        disabled={isLoading}
                                        value={autoCompleteSelectedOption}
                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                        onChange={(event, newValue) => { handleAdicionarJogador(Number(newValue?.codigo)); }}
                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 16 : 28} /> : undefined}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Meus Jogadores"
                                                slotProps={{
                                                    inputLabel: {
                                                        style: {
                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                        }
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                {/* <Grid size={{ xs: 12, sm: 6, md: 7 }} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={() => { handleAdicionarJogador(); }}
                                        startIcon={<Icon>check</Icon>}
                                    >
                                        Adicionar
                                    </Button>
                                </Grid> */}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {lstRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={lstRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 16,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                                quantidade_Jogos: false,
                                                ast: lstRows.filter(f => f.ast === null).length === 0,
                                                blk: lstRows.filter(f => (f.blk === null)).length === 0,
                                                dreb: lstRows.filter(f => (f.dreb === null)).length === 0,
                                                fga: lstRows.filter(f => (f.fga === null)).length === 0,
                                                fgm: lstRows.filter(f => f.fgm === null).length === 0,
                                                fgmp: lstRows.filter(f => (f.fgmp === null)).length === 0,
                                                fta: lstRows.filter(f => (f.fta === null)).length === 0,
                                                ftm: lstRows.filter(f => (f.ftm === null)).length === 0,
                                                ftmp: lstRows.filter(f => (f.ftmp === null)).length === 0,
                                                min: lstRows.filter(f => (f.min === null)).length === 0,
                                                mplu: lstRows.filter(f => (f.mplu === null)).length === 0,
                                                oreb: lstRows.filter(f => (f.oreb === null)).length === 0,
                                                pf: lstRows.filter(f => (f.pf === null)).length === 0,
                                                pts: lstRows.filter(f => (f.pts === null)).length === 0,
                                                reb: lstRows.filter(f => (f.reb === null)).length === 0,
                                                stl: lstRows.filter(f => (f.stl === null)).length === 0,
                                                threepa: lstRows.filter(f => (f.threepa === null)).length === 0,
                                                threepm: lstRows.filter(f => (f.threepm === null)).length === 0,
                                                threepmp: lstRows.filter(f => (f.threepmp === null)).length === 0,
                                                to: lstRows.filter(f => (f.to === null)).length === 0,
                                                fge: lstRows.filter(f => (f.fge === null)).length === 0,
                                                fte: lstRows.filter(f => (f.fte === null)).length === 0,
                                                threepe: lstRows.filter(f => (f.threepe === null)).length === 0,
                                                stocks: lstRows.filter(f => (f.stocks === null)).length === 0,
                                            }}
                                            editMode="row"
                                            rowModesModel={rowModesModel}

                                            slotProps={{
                                                toolbar: { setEstatisticasRows, setRowModesModel },
                                            }}
                                            pageSizeOptions={[16, 25, 50, 100]}
                                            disableRowSelectionOnClick
                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                            }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid container size={{ xs: 11, sm: 12 }} margin={1} paddingTop={1} spacing={1} display="flex" justifyItems="center" >
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <Autocomplete
                                        openText="Abrir"
                                        closeText="Fechar"
                                        noOptionsText="Sem opções"
                                        loadingText="Carregando..."
                                        disablePortal
                                        options={opcoesAutoCompleteJogadorTodos}
                                        loading={isLoading}
                                        disabled={isLoading}
                                        value={autoCompleteSelectedOptionTodos}
                                        size={UtilidadeService.isMobile() ? "small" : "medium"}
                                        onChange={(event, newValue) => { handleAdicionarJogadorTodos(Number(newValue?.codigo)); }}
                                        popupIcon={isLoading ? <CircularProgress size={UtilidadeService.isMobile() ? 20 : 28} /> : undefined}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Todos Jogadores"
                                                slotProps={{
                                                    inputLabel: {
                                                        style: {
                                                            fontSize: UtilidadeService.isMobile() ? 13 : 16
                                                        }
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                                {/* <Grid size={{ xs: 12, sm: 6, md: 7 }} display="flex" alignItems="center" justifyContent="center" justifyItems="center" textAlign="end">
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disableElevation
                                        onClick={() => { handleAdicionarJogadorTodos(); }}
                                        startIcon={<Icon>check</Icon>}
                                    >
                                        Adicionar
                                    </Button>
                                </Grid> */}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {lstRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.codigo}
                                            rows={lstTodosRows}
                                            columns={columnsGeralTodos}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 16,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                codigo: false,
                                                quantidade_Jogos: false,
                                                ast: lstTodosRows.filter(f => f.ast === null).length === 0,
                                                blk: lstTodosRows.filter(f => (f.blk === null)).length === 0,
                                                dreb: lstTodosRows.filter(f => (f.dreb === null)).length === 0,
                                                fga: lstTodosRows.filter(f => (f.fga === null)).length === 0,
                                                fgm: lstTodosRows.filter(f => f.fgm === null).length === 0,
                                                fgmp: lstTodosRows.filter(f => (f.fgmp === null)).length === 0,
                                                fta: lstTodosRows.filter(f => (f.fta === null)).length === 0,
                                                ftm: lstTodosRows.filter(f => (f.ftm === null)).length === 0,
                                                ftmp: lstTodosRows.filter(f => (f.ftmp === null)).length === 0,
                                                min: lstTodosRows.filter(f => (f.min === null)).length === 0,
                                                mplu: lstTodosRows.filter(f => (f.mplu === null)).length === 0,
                                                oreb: lstTodosRows.filter(f => (f.oreb === null)).length === 0,
                                                pf: lstTodosRows.filter(f => (f.pf === null)).length === 0,
                                                pts: lstTodosRows.filter(f => (f.pts === null)).length === 0,
                                                reb: lstTodosRows.filter(f => (f.reb === null)).length === 0,
                                                stl: lstTodosRows.filter(f => (f.stl === null)).length === 0,
                                                threepa: lstTodosRows.filter(f => (f.threepa === null)).length === 0,
                                                threepm: lstTodosRows.filter(f => (f.threepm === null)).length === 0,
                                                threepmp: lstTodosRows.filter(f => (f.threepmp === null)).length === 0,
                                                to: lstTodosRows.filter(f => (f.to === null)).length === 0,
                                                fge: lstTodosRows.filter(f => (f.fge === null)).length === 0,
                                                fte: lstTodosRows.filter(f => (f.fte === null)).length === 0,
                                                threepe: lstTodosRows.filter(f => (f.threepe === null)).length === 0,
                                                stocks: lstTodosRows.filter(f => (f.stocks === null)).length === 0,
                                            }}
                                            editMode="row"
                                            rowModesModel={rowModesModel}

                                            slotProps={{
                                                toolbar: { setEstatisticasRows, setRowModesModel },
                                            }}
                                            pageSizeOptions={[16, 25, 50, 100]}
                                            disableRowSelectionOnClick
                                            disableColumnFilter={UtilidadeService.isMobile() ? true : false}
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ? 12 : 16,
                                            }}
                                        />
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


